import { useEffect, useState } from 'react';

import { useAuth } from '../context/AuthContext';

const storageKey = (userId: string) => `disposable_notice_shown:${userId}`;

/**
 * Shows the "temporary email detected" notice once per user in this browser.
 *
 * Safety net for auth paths that skip the email-register flow (OAuth signups,
 * verify-email auto-login): when the logged-in user signed up with a
 * disposable email and hasn't seen the notice yet, open it once and remember
 * the dismissal in localStorage.
 */
export const useDisposableEmailNotice = () => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (user?.disposableEmail && !localStorage.getItem(storageKey(user.id))) {
      setIsOpen(true);
    }
  }, [user?.id, user?.disposableEmail]);

  const onClose = () => {
    if (user) localStorage.setItem(storageKey(user.id), '1');
    setIsOpen(false);
  };

  return { isOpen, onClose };
};
